import { useDispatch } from "react-redux";
import { SelectChangeEvent } from "@mui/material/Select";

import { AdminTypes } from "../../../components/Menu";
import { CustomSelect } from "../../../shared/uiComponents";
import { useScreenWidth } from "../../../shared/Helpers/hooks";
import StartSession from "./startSession";
import CalendarFilters from "./filters";
import AdminTools from "./adminTools";
import Navigation from "./navigation";

import { DispatchProperties, useSelector } from "../../../redux/store";
import { setCalendarView } from "../../../redux/State/clientSlice/calendarSlice";

const CalendarHeader = () => {
  const dispatch = useDispatch<DispatchProperties>();
  const screenWidth = useScreenWidth();

  const role = useSelector((state) => state.account.role);
  const viewer = useSelector((state) => state.calendar.calendarView);
  const { client, therapist } = useSelector(
    (state) => state.calendar.filterData
  );

  const isAdminToolVisible = role?.section.id === AdminTypes.admin ||
    role?.section.id === AdminTypes.cs;

  const viewHandler = (event: SelectChangeEvent<string>) => {
    const value = parseInt(event.target.value);
    dispatch(setCalendarView(value));
  };

  return (
    <>
      <div className="calendarHeader">
        <Navigation />
        <CalendarFilters />
        <div style={{
          display: "flex",
          alignItems: "center",
          width: '20%',
          justifyContent: 'flex-end',
          flexWrap: 'wrap',
          gap: 16,
        }}>
          {screenWidth > 425 && (
            <CustomSelect
              data={[
                { id: "0", name: "month" },
                { id: "1", name: "week" },
              ]}
              value={`${viewer}`}
              setValue={viewHandler}
            />
          )}
          {!therapist?.id && !client?.id && <StartSession />}
        </div>
      </div>
      {isAdminToolVisible && <AdminTools />}
    </>
  );
};

export default CalendarHeader;
